import { API_ENDPOINTS } from '../config/api'
import { getActiveOrgId } from '../utils/orgUtils'

export type ControlStatus =
  | 'ENABLED'
  | 'DISABLED'
  | 'PARTIAL'
  | 'UNKNOWN'
  | 'NOT_APPLICABLE'

export type VerificationState =
  | 'VERIFIED'
  | 'DISCOVERED'
  | 'SELF_REPORTED'
  | 'MANUALLY_VERIFIED'
  | 'STALE'
  | 'UNKNOWN'

export type SecurityControlRow = {
  controlType: string
  label?: string
  applicableAssets: number
  enabled: number
  disabled: number
  partial: number
  unknown: number
  notApplicable?: number
  stale?: number
  knownAssets?: number
  verifiedAssets?: number
  selfReported?: number
  knownCoveragePercent: number | null
  verifiedCoveragePercent: number | null
  enabledCoveragePercent?: number | null
}

export type CoverageGap = {
  id: string
  controlType: string
  controlStatus: string
  severity: string
  assetCount: number
  message: string
  messageKey?: string
}

export type SecurityProtectionCoverage = {
  empty: boolean
  hasKnownData?: boolean
  hasVerifiedData?: boolean
  summary: {
    totalAssets: number
    applicableAssets: number
    coveredAssets: number
    knownAssets?: number
    verifiedAssets: number
    unknownAssets: number
    attentionAssets: number
    knownCoveragePercent?: number | null
    verifiedCoveragePercent: number | null
    lastUpdatedAt: string | null
  }
  dataQuality?: {
    verified: number
    discovered: number
    selfReported: number
    manuallyVerified?: number
    stale: number
    unknown: number
  }
  controls: SecurityControlRow[]
  topCoverageGaps: CoverageGap[]
}

export async function fetchSecurityProtectionCoverage(
  token: string | null | undefined,
  organizationId?: string | null,
): Promise<SecurityProtectionCoverage | null> {
  const org = organizationId || getActiveOrgId()
  if (!org || !token) return null
  const url = `${API_ENDPOINTS.ORG_SECURITY_PROTECTION_COVERAGE(org)}`
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } })
  if (!res.ok) return null
  const dto = await res.json()
  return dto?.securityProtectionCoverage || null
}

export {
  buildSecurityControlInventoryUrl as securityControlInventoryUrl,
  buildSecurityControlInventoryUrl,
  buildSecurityControlSearchParams,
  parseSecurityControlInventoryFilters,
  assetMatchesSecurityControlFilters,
  filterAssetsBySecurityControlInventory,
  hasActiveSecurityControlFilters,
  clearSecurityControlParams,
  type BuildInventoryUrlOpts,
  type SecurityControlInventoryFilters,
  type SecurityCoverageMode,
} from './securityControlInventoryFilters'
